(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-announcement]').forEach(function (bar) {
      var items = bar.querySelectorAll('.announcement__item');
      if (items.length < 2) return;
      var i = 0, timer;
      var interval = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;
      function show(n) {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      }
      function start() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, interval); }
      bar.querySelectorAll('[data-announcement-step]').forEach(function (b) {
        b.addEventListener('click', function () { show(i + parseInt(b.getAttribute('data-announcement-step'), 10)); start(); });
      });
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', start);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var wrapper = drawer.closest('.shopify-section');
    var sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : 'cart-drawer';

    function open() { if (!drawer.open) drawer.showModal(); }
    function close() { if (drawer.open) drawer.close(); }

    function swapPanel(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-panel]');
      var current = drawer.querySelector('[data-cart-drawer-panel]');
      if (fresh && current) current.replaceWith(fresh);
      // Read from the drawer: the fresh panel, count included, has just moved out of the parsed document
      var count = drawer.querySelector('[data-cart-drawer-count]');
      var n = count ? parseInt(count.getAttribute('data-cart-drawer-count'), 10) : 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
      document.dispatchEvent(new CustomEvent('flosh:cart:updated'));
    }

    // Fresh render of this section for the current cart; never from the browser cache.
    function rerender() {
      drawer.classList.add('is-busy');
      return fetch(window.location.pathname + '?sections=' + sectionId + '&t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (data) { swapPanel(data[sectionId]); })
        .catch(function (error) { console.warn('cart-drawer: could not refresh', error); })
        .finally(function () { drawer.classList.remove('is-busy'); });
    }

    // One request: change the line and get the re-rendered drawer back in the same response.
    function change(line, quantity) {
      drawer.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        cache: 'no-store',
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) { console.warn('cart-drawer: change refused', result.data); return rerender(); }
          var html = result.data && result.data.sections && result.data.sections[sectionId];
          if (html) { swapPanel(html); return; }
          return rerender();
        })
        .catch(function (error) { console.warn('cart-drawer: change failed', error); return rerender(); })
        .finally(function () { drawer.classList.remove('is-busy'); });
    }

    // Header cart icon opens the drawer instead of navigating. The panel is already server-rendered
    // for this cart, so open at once; the background refresh only matters if the cart changed elsewhere.
    document.querySelectorAll('.header__cart').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(); rerender(); });
    });

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) { close(); return; }
      if (e.target.closest('[data-cart-drawer-close]')) { close(); return; }
      var scrollBtn = e.target.closest('[data-picks-scroll]');
      if (scrollBtn) {
        var track = drawer.querySelector('[data-picks-track]');
        if (track) track.scrollBy({ left: 240 * parseInt(scrollBtn.getAttribute('data-picks-scroll'), 10), behavior: 'smooth' });
        return;
      }
      var btn = e.target.closest('[data-cart-change]');
      if (!btn) return;
      var line = parseInt(btn.getAttribute('data-cart-change'), 10);
      if (btn.hasAttribute('data-set')) { change(line, parseInt(btn.getAttribute('data-set'), 10)); return; }
      var input = drawer.querySelector('[data-cart-qty="' + line + '"]');
      var next = Math.max(0, (parseInt(input && input.value, 10) || 0) + parseInt(btn.getAttribute('data-delta'), 10));
      change(line, next);
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (input) change(parseInt(input.getAttribute('data-cart-qty'), 10), Math.max(0, parseInt(input.value, 10) || 0));
    });

    // Anything added anywhere (card plus buttons, bundle, drawer picks): the drawer opens the
    // moment the add starts (busy state), and the add response carries the re-rendered drawer,
    // so no second request is needed before the new line shows.
    document.addEventListener('flosh:cart:adding', function () { drawer.classList.add('is-busy'); open(); });
    document.addEventListener('flosh:cart:added', function (e) {
      open();
      var html = e.detail && e.detail.sections && e.detail.sections[sectionId];
      if (html) { swapPanel(html); drawer.classList.remove('is-busy'); } else { rerender(); }
    });
    document.addEventListener('flosh:cart:add-failed', function () { rerender(); });

    // The product form: add via AJAX, drawer open at once, fresh panel from the same response
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        var body = new FormData(form);
        body.append('sections', sectionId);
        body.append('sections_url', window.location.pathname);
        drawer.classList.add('is-busy');
        open();
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, cache: 'no-store', body: body })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error((result.data && result.data.description) || 'add failed');
            var html = result.data && result.data.sections && result.data.sections[sectionId];
            if (html) { swapPanel(html); return; }
            return rerender();
          })
          .catch(function (error) { console.warn('cart-drawer: add failed', error); close(); form.submit(); })
          .finally(function () { drawer.classList.remove('is-busy'); if (submit) submit.disabled = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.cart__form').forEach(function (form) {
    form.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('[data-qty-input]');
        if (!input) return;
        var next = parseInt(input.value || '0', 10) + parseInt(btn.getAttribute('data-qty-step'), 10);
        input.value = Math.max(0, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    form.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        form.classList.add('is-dirty');
        clearTimeout(form._qtyTimer);
        form._qtyTimer = setTimeout(function () { form.querySelector('[name="update"]').click(); }, 600);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('HeaderDrawer');
    document.querySelectorAll('[data-header-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (drawer && !drawer.open) { drawer.showModal(); drawer.focus(); } });
    });
    document.querySelectorAll('[data-header-close]').forEach(function (b) {
      b.addEventListener('click', function () { if (drawer) drawer.close(); });
    });
    if (drawer) drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });

    // Cart: plus buttons on product cards and any [data-add-variant]
    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    }
    // Plus buttons everywhere (cards, bundle, drawer picks). One request: the add response also
    // carries the re-rendered cart drawer (sections + sections_url), which the drawer swaps in.
    var drawerEl = document.getElementById('CartDrawer');
    var drawerWrap = drawerEl && drawerEl.closest('.shopify-section');
    var drawerSection = drawerWrap ? drawerWrap.id.replace('shopify-section-', '') : '';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-variant]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      var items = [];
      String(btn.getAttribute('data-add-variant')).split(',').forEach(function (id) {
        if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
      });
      var payload = { items: items };
      if (drawerSection) { payload.sections = drawerSection; payload.sections_url = window.location.pathname; }
      document.dispatchEvent(new CustomEvent('flosh:cart:adding', { detail: { button: btn } }));
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        cache: 'no-store',
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error((result.data && result.data.description) || 'add failed');
          btn.classList.add('is-added');
          var sections = result.data && result.data.sections ? result.data.sections : null;
          document.dispatchEvent(new CustomEvent('flosh:cart:added', { detail: { button: btn, sections: sections } }));
          if (sections) return;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) { setCount(cart.item_count); });
        })
        .catch(function (error) {
          console.warn('header: add failed', error);
          btn.classList.add('is-error');
          document.dispatchEvent(new CustomEvent('flosh:cart:add-failed', { detail: { button: btn } }));
        })
        .finally(function () { btn.disabled = false; setTimeout(function () { btn.classList.remove('is-added', 'is-error'); }, 1500); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bundle]').forEach(function (root) {
      var boxes = root.querySelectorAll('[data-bundle-item]');
      var total = root.querySelector('[data-bundle-total]');
      var button = root.querySelector('[data-bundle-add]');
      function format(cents) {
        var n = (cents / 100).toFixed(2).replace('.', ',');
        return '€ ' + n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      function update() {
        var sum = 0, ids = [];
        boxes.forEach(function (b) {
          if (b.checked) {
            sum += parseInt(b.getAttribute('data-price'), 10) || 0;
            ids.push(b.getAttribute('data-bundle-item'));
          }
        });
        if (total) total.textContent = format(sum);
        if (button) {
          button.setAttribute('data-add-variant', ids.join(','));
          button.disabled = ids.length === 0;
        }
      }
      boxes.forEach(function (b) { b.addEventListener('change', update); });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-carousel').forEach(function (section) {
    var track = section.querySelector('[data-carousel-track]');
    if (!track) return;
    function step(direction) {
      var card = track.firstElementChild;
      var width = card ? card.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: width * direction, behavior: 'smooth' });
    }
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-parts"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-parts').forEach(function (section) {
    var track = section.querySelector('.product-parts__list--scroll');
    if (!track) return;
    function step(direction) {
      var item = track.firstElementChild;
      var width = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : 300;
      track.scrollBy({ left: width * direction, behavior: 'smooth' });
    }
    var prev = section.querySelector('[data-parts-prev]');
    var next = section.querySelector('[data-parts-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('variant-price')) {
    class VariantPrice extends HTMLElement {
      connectedCallback() {
        const scope = this.closest('.shopify-section') || document;
        scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((input) => {
          input.addEventListener('change', (event) => this.update(event.target.value));
        });
      }

      async update(variantId) {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();

        try {
          // Ask for the small price fragment (sections/product-price-fragment.liquid) instead of
          // re-rendering the whole product section with its gallery; fall back to the section.
          let html = await this.fetchSection('product-price-fragment', variantId);
          let fresh = html && html.querySelector('.shopify-section');
          if (!fresh) {
            html = await this.fetchSection(this.dataset.sectionId, variantId);
            fresh = html && html.getElementById(this.id);
          }
          if (fresh) this.innerHTML = fresh.innerHTML;

          const pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', pageUrl);
        } catch (error) {
          if (error.name !== 'AbortError') throw error;
        }
      }

      async fetchSection(sectionId, variantId) {
        const url = new URL(window.location.pathname, window.location.origin);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      }
    }

    customElements.define('variant-price', VariantPrice);
  }

  // Quantity stepper, buy-button availability, sticky buy bar
  (function () {
    document.querySelectorAll('.product').forEach(function (root) {
      var section = root.closest('.shopify-section') || root;
      var form = root.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      var submit = form.querySelector('[data-product-submit]');
      var bar = section.querySelector('[data-product-stickybar]');
      var stickySubmit = bar ? bar.querySelector('[data-sticky-submit]') : null;
      var stickyPrice = bar ? bar.querySelector('[data-sticky-price]') : null;
      var stock = form.querySelector('[data-product-stock]');
      var variants = [];
      var json = root.querySelector('[data-product-variants]');
      try { variants = JSON.parse(json ? json.textContent : '[]'); } catch (e) {}
      var labels = { add: root.getAttribute('data-label-add'), soldOut: root.getAttribute('data-label-sold-out') };

      root.querySelectorAll('[data-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var next = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
          qty.value = Math.max(1, next);
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      function setAvailability(variantId) {
        var v = variants.find(function (x) { return String(x.id) === String(variantId); });
        var available = v ? v.available : true;
        [submit, stickySubmit].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = !available;
          var label = btn.querySelector('[data-submit-label]');
          if (label) label.textContent = available ? labels.add : labels.soldOut;
        });
        if (stickyPrice && v) stickyPrice.textContent = v.price;
        if (v) {
          var stickyVariant = bar ? bar.querySelector('[data-sticky-variant]') : null;
          if (stickyVariant) stickyVariant.textContent = v.title;
          section.querySelectorAll('[data-product-free], [data-sticky-free]').forEach(function (el) { el.hidden = !v.free; });
          var choicePrice = root.querySelector('[data-choice-price]');
          if (choicePrice) choicePrice.textContent = v.price;
        }
        if (stock) {
          var left = v && typeof v.stock === 'number' ? v.stock : 0;
          var lowAt = parseInt(stock.getAttribute('data-low-at'), 10) || 0;
          var plenty = stock.getAttribute('data-text-plenty');
          var text = stock.querySelector('[data-product-stock-text]');
          if (text && left > 0) {
            if (lowAt > 0 && left > lowAt && plenty) {
              text.textContent = plenty;
            } else {
              // The stock text is escaped server-side; only [aantal] becomes markup
              var holder = document.createElement('span');
              holder.textContent = stock.getAttribute('data-text-low') || '';
              text.innerHTML = holder.innerHTML.replace('[aantal]', '<b data-product-stock-count>' + left + '</b>');
            }
          }
          stock.hidden = !(left > 0);
        }
        updateChoice(variantId);
      }

      // The other product of the choice opens in the same wood
      var choiceLink = root.querySelector('[data-choice-link]');
      var choiceData = null;
      try {
        var choiceJson = root.querySelector('[data-choice-variants]');
        choiceData = choiceJson ? JSON.parse(choiceJson.textContent) : null;
      } catch (e) {}
      function updateChoice(variantId) {
        if (!choiceLink || !choiceData) return;
        var wood = choiceData.variants[String(variantId)];
        if (wood && choiceData.options[wood]) choiceLink.href = choiceData.options[wood];
      }

      // "Vandaag besteld, uiterlijk [datum] in huis": order day plus N working days (Sat/Sun skipped).
      // Worked out in the browser, because a cached page would carry yesterday's date.
      var delivery = form.querySelector('[data-delivery-line]');
      if (delivery) {
        var template = delivery.getAttribute('data-template') || '';
        var days = parseInt(delivery.getAttribute('data-days'), 10) || 2;
        var date = new Date();
        while (days > 0) {
          date.setDate(date.getDate() + 1);
          if (date.getDay() !== 0 && date.getDay() !== 6) days--;
        }
        var label = date.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' });
        if (template.indexOf('[datum]') > -1) {
          var parts = template.split('[datum]');
          delivery.textContent = parts[0];
          var strong = document.createElement('b');
          strong.textContent = label;
          delivery.append(strong, parts.slice(1).join(label));
        }
      }
      if (idInput) idInput.addEventListener('change', function () { setAvailability(idInput.value); });

      if (stickySubmit) {
        stickySubmit.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }

      if (bar && submit && 'IntersectionObserver' in window) {
        // The bar hovers at the bottom whenever the real buy button is not on screen
        // (below the fold on phones, scrolled past on desktop), and steps aside for the footer.
        var buttonInView = true;
        var priceInView = false;
        var fromStart = bar.hasAttribute('data-from-start');
        var footerInView = false;
        var paintBar = function () {
          // Not while the price is still on screen (the first screen shows price and discount) and not over
          // the footer, unless the theme setting keeps a buy button in reach everywhere: then only the real
          // button sends it away, and the page gets room at the bottom so the bar covers no footer links
          var on = fromStart ? !buttonInView : !buttonInView && !priceInView && !footerInView;
          bar.classList.toggle('is-visible', on);
          if (fromStart) document.body.style.paddingBottom = on ? bar.offsetHeight + 'px' : '';
          bar.setAttribute('aria-hidden', String(!on));
        };
        new IntersectionObserver(function (entries) {
          buttonInView = entries[0].isIntersecting;
          paintBar();
        }, { threshold: 0.2 }).observe(submit);
        var priceBlock = root.querySelector('.product__price');
        if (priceBlock) {
          new IntersectionObserver(function (entries) {
            priceInView = entries[0].isIntersecting;
            paintBar();
          }).observe(priceBlock);
        }
        // Every part of the footer group counts (the customer service band and the footer itself)
        var footerParts = document.querySelectorAll('.shopify-section-group-footer-group, footer');
        if (footerParts.length && bar.hasAttribute('data-hide-at-footer')) {
          var partsInView = new Set();
          var footerWatch = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) partsInView.add(entry.target); else partsInView.delete(entry.target);
            });
            footerInView = partsInView.size > 0;
            paintBar();
          });
          footerParts.forEach(function (part) { footerWatch.observe(part); });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.reviews').forEach(function (root) {
    var track = root.querySelector('[data-reviews-track]');
    root.querySelectorAll('[data-reviews-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!track) return;
        var first = track.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 16 : 320;
        track.scrollBy({ left: step * parseInt(btn.getAttribute('data-reviews-scroll'), 10), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shop-look').forEach(function (root) {
    var pins = root.querySelectorAll('[data-pin]');
    pins.forEach(function (pin) {
      pin.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var open = pin.classList.contains('is-open');
        pins.forEach(function (p) { p.classList.remove('is-open'); });
        if (!open) pin.classList.add('is-open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.shop-look__pin')) pins.forEach(function (p) { p.classList.remove('is-open'); });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
